/**
 * Core
 */
import React, { useEffect, useState, useRef } from "react";
import Start from "./components/Start";
import { createPortal } from "react-dom";
import ArrowButton from "./components/ArrowButton";
import Preview from "./components/Preview";
import Gender from "./components/Gender";
import Name from "./components/Name";
import Birthday from "./components/Birthday";
import Email from "./components/Email";
import Password from "./components/Password";
import { simplyClick } from "./helpers";

function App() {
  const [step, setStep] = useState(1);
  const arrowButton = document.getElementById("arrow__button");
  const executedRef = useRef(false);

  let content = null;

  useEffect(() => {
    const mainWrapper = document.querySelector(".content__wrapper-inner");
    const loginButton = document.querySelector(".login");
    if (mainWrapper && step >= 2) {
      mainWrapper.classList.add("blur");
    }
    const clickHandler = () => {
      if (!executedRef.current) {
        simplyClick("cl_lnd_am31_sign", null, false);
        executedRef.current = true;
      }
    };
    loginButton.addEventListener("click", clickHandler);
    return () => {
      loginButton.removeEventListener("click", clickHandler);
    };
  }, [step]);

  switch (step) {
    case 1:
      content = <Start step={step} setStep={setStep} />;
      break;
    case 2:
      content = (
        <Preview
          textOne={" Many of our members seek regular communication."}
          textTwo={"Does that align with what you are looking for?"}
          setStep={setStep}
          step={step}
          cbStepNext={() => simplyClick("cl_lnd_am31_look_for_yes", null)}
          cbStepSkip={() => simplyClick("cl_lnd_am31_look_for_skip", null)}
        />
      );
      break;
    case 3:
      content = (
        <Preview
          textOne={
            "Our community values open-mindedness most and is all about sharing their experiences. Are you interested in it?"
          }
          setStep={setStep}
          step={step}
          cbStepNext={() => simplyClick("cl_lnd_am31_interest_yes", null)}
          cbStepSkip={() => simplyClick("cl_lnd_am31_interest_skip", null)}
        />
      );
      break;
    case 4:
      content = (
        <Preview
          textOne={
            "Do you find it exciting to finally engage in a profound conversation with someone?"
          }
          setStep={setStep}
          step={step}
          cbStepNext={() => simplyClick("cl_lnd_am31_engage_yes", null)}
          cbStepSkip={() => simplyClick("cl_lnd_am31_engage_skip", null)}
        />
      );
      break;
    case 5:
      content = <Gender step={step} setStep={setStep} />;
      break;
    case 6:
      content = <Name setStep={setStep} step={step} />;
      break;
    case 7:
      content = <Birthday setStep={setStep} step={step} />;
      break;
    case 8:
      content = <Email setStep={setStep} step={step} />;
      break;
    case 9:
      content = <Password setStep={setStep} step={step} />;
      break;
    default:
  }

  return (
    <>
      {step === 1 &&
        createPortal(
          <ArrowButton step={step} setStep={setStep} />,
          arrowButton
        )}
      {content}
    </>
  );
}

export default App;
